module.exports = __webpack_public_path__ + "./img/LogoSCM-horizontal.b586b2caded064d1415ce2c2af8fc7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/LogoSCM-horizontal.png
// module id = ./src/assets/img/brand/LogoSCM-horizontal.png
// module chunks = 11